import { render, staticRenderFns } from "./nonPremiumPreflightScreen.vue?vue&type=template&id=56a29348&scoped=true&"
import script from "./nonPremiumPreflightScreen.vue?vue&type=script&lang=js&"
export * from "./nonPremiumPreflightScreen.vue?vue&type=script&lang=js&"
import style0 from "./nonPremiumPreflightScreen.vue?vue&type=style&index=0&id=56a29348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a29348",
  null
  
)

export default component.exports